var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modal",
    {
      ref: "modalMultidamageForm",
      attrs: { type: "full" },
      on: { "modal:close": _vm.resetForms },
    },
    [
      !_vm.loading
        ? _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main view" },
              [
                _c("ma-notifications"),
                _c("div", { staticClass: "view_content" }, [
                  _c("div", { staticClass: "view_content_markdown" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          _vm.damagedPart && _vm.damagedPart.literal
                            ? _vm.damagedPart.literal
                            : ""
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "ul",
                    { staticClass: "listForms" },
                    _vm._l(_vm.formData, function (form) {
                      return _c(
                        "li",
                        { staticClass: "mg mg--t-4 mg--b-2" },
                        [
                          _c("ma-form", {
                            ref: "form",
                            refInFor: true,
                            attrs: {
                              type: "large",
                              categoryLiteral: _vm.damagedPart.literal,
                              formData: form.form,
                              showDropDown: false,
                              showLiteral: false,
                              nameFileInputEnsemble: "inputImgEnsemble",
                              titleFileInputEnsemble: _vm.$t(
                                "damageDetails.titleFileInputEnsemble"
                              ),
                              inputImgListEnsemble: _vm.imgListEnsemble,
                              nameFileInputPres: "inputImgPres",
                              titleFileInputPres: _vm.$t(
                                "damageDetails.titleFileInputPres"
                              ),
                              inputImgListPres: _vm.imgListPres,
                              showSpinner: _vm.spinner,
                            },
                            on: {
                              "file:change-ensemble":
                                _vm.handleOnImgChangeEnsemble,
                              "file:change-pres": _vm.handleOnImgChangePres,
                              change: function ($event) {
                                _vm.handleOnChange($event)
                                _vm.handleOnFormChange($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "view_actions" },
              [
                _c("maButton", {
                  attrs: {
                    handleButtonClick: _vm.handleOnAddDamagePart,
                    title: _vm.$t("multidamageList.btnAddDamageModal"),
                    shouldBeDisabled: _vm.isDisabledBtn,
                    btnType: "functionalBtn",
                  },
                }),
              ],
              1
            ),
          ])
        : _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main has-modal" },
              [_c("maSpinner", { staticClass: "spinner" })],
              1
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }